import React from 'react'
import { useIntl } from 'react-intl'

import Image from 'src/comps/Image'
import { ImageApiObject } from 'src/types/image'
import Pill from 'src/comps/Atom/Pill'

import { getResponsiveImgProps } from '../utils'
import { thumbnailImageSizes } from '../constants'

import styles from './styles.module.css'

interface IShowMoreThumbnailProps {
  handleClick: () => void
  image: ImageApiObject
  photosCount: number
}

export function ShowMoreThumbnail(props: Readonly<IShowMoreThumbnailProps>) {
  const { handleClick, image, photosCount } = props
  const intl = useIntl()

  return (
    <button className={styles.thumbnailButtonBase} type="button" onClick={handleClick}>
      <Image alt="thumbnail" {...getResponsiveImgProps(image, thumbnailImageSizes)} />
      <Pill label={`${intl.formatMessage({ id: 'image.gallery-all-photos' })} (${photosCount})`} />
    </button>
  )
}
